var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTerritory(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.4819 51.9528C76.6667 54.0553 76.6667 56.6761 76.6667 60C76.6667 66.8894 76.6667 70.7582 75.021 73.2522L65.1019 63.333L76.4819 51.9528Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2535 75.0201L63.3341 65.1008L51.9528 76.4818C54.0553 76.6667 56.6761 76.6667 60 76.6667C66.8906 76.6667 70.7596 76.6667 73.2535 75.0201Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 43.3333C67.8568 43.3333 71.7852 43.3333 74.2259 45.7741C75.0657 46.6139 75.6166 47.6298 75.9779 48.9212L48.9212 75.9778C47.6298 75.6165 46.6139 75.0657 45.7742 74.2259C43.3334 71.7851 43.3334 67.8567 43.3334 60C43.3334 52.1433 43.3334 48.2149 45.7742 45.7741C48.2149 43.3333 52.1433 43.3333 60 43.3333ZM49.1667 54.5955C49.1667 57.5703 51.0285 61.0416 53.9333 62.283C54.6105 62.5723 55.3896 62.5723 56.0668 62.283C58.9716 61.0416 60.8334 57.5703 60.8334 54.5955C60.8334 51.5973 58.2217 49.1667 55 49.1667C51.7784 49.1667 49.1667 51.5973 49.1667 54.5955Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 55C57.5 56.3807 56.3808 57.5 55 57.5C53.6193 57.5 52.5 56.3807 52.5 55C52.5 53.6193 53.6193 52.5 55 52.5C56.3808 52.5 57.5 53.6193 57.5 55Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerritory);
export default __webpack_public_path__ + "static/media/Territory.7deefce12c8471bf22b293dbe62d15b9.svg";
export { ForwardRef as ReactComponent };